/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var react_1 = require("react");
var ReactDOM = require("react-dom");
var classnames = require("classnames");
var Spinner_1 = require("./Spinner");
var propertyToMCSSstate_1 = require("./util/propertyToMCSSstate");
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Button.css'); }
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-button");
exports.ButtonKindsArray = [
    "primaryRaised",
    "primary",
    "primaryWarning",
    "secondary",
    "ghost",
    "ghostMuted",
    "ghostWarning",
    "decision"
];
exports.ButtonSizesArray = ["small", "large", "medium"];
exports.ButtonTagNamesArray = ["button", "a", "input"];
var Button = /** @class */ (function (_super) {
    tslib_1.__extends(Button, _super);
    function Button() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (event) {
            if (_this.props.almostActive) {
                _this.shake();
            }
            if (_this.props.disabled) {
                _this.shake();
                return undefined;
            }
            if (_this.props.onClick) {
                return _this.props.onClick(event);
            }
        };
        _this.shake = function () {
            var node = _this.getDOMNode();
            var isShakingClass = moduleClassName("isShaking");
            if (node && node.classList.contains(isShakingClass)) {
                node.classList.remove(isShakingClass);
                node.getBoundingClientRect();
            }
            node.classList.add(isShakingClass);
        };
        return _this;
    }
    Button.prototype.componentDidUpdate = function () {
        if (this.disabledClick) {
            this.disabledClick.removeEventListener("click", this.shake);
            this.disabledClick.addEventListener("click", this.shake);
        }
    };
    Button.prototype.buildCssClasses = function () {
        // eslint-disable-line max-statements
        var _a = this.props, block = _a.block, disabled = _a.disabled, className = _a.className, _b = _a.size, size = _b === void 0 ? "medium" : _b, wide = _a.wide, _c = _a.kind, kind = _c === void 0 ? "primary" : _c, colorOverride = _a.colorOverride, waiting = _a.waiting, almostActive = _a.almostActive;
        return [
            moduleClassName(),
            moduleClassName(kind),
            className,
            !!block && moduleClassName("block"),
            size !== "medium" && moduleClassName(size),
            !!colorOverride && propertyToMCSSstate_1.propertyToMCSSstate(moduleClassName(), colorOverride),
            !!wide && moduleClassName("isWide"),
            !!waiting && moduleClassName("isWaiting"),
            !!disabled && moduleClassName("isDisabled"),
            // only add "almostActive" classes, when the prop is defined
            almostActive !== undefined && moduleClassName("isAlmostActive"),
            // if it is false, we can expect the button to have been "almostActive" before
            // (this is required for the animation between "almostActive" and "active")
            almostActive === false && moduleClassName("wasAlmostActive")
        ];
    };
    Button.prototype.getDOMNode = function () {
        return ReactDOM.findDOMNode(this);
    };
    Button.prototype.renderChildren = function () {
        var _this = this;
        var _a = this.props, waiting = _a.waiting, disabled = _a.disabled, children = _a.children;
        if (waiting) {
            return [
                React.createElement("span", { key: "btn-children" }, children),
                React.createElement(Spinner_1.Spinner, { key: "btn-spinner", className: "ok" })
            ];
        }
        if (disabled) {
            return [
                React.createElement("span", { key: "btn-children" }, children),
                React.createElement("span", { key: "btn-disabled", ref: function (el) { return (_this.disabledClick = el); }, className: moduleClassName("disabledShaker") }, children)
            ];
        }
        return children;
    };
    Button.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, size = _a.size, block = _a.block, wide = _a.wide, kind = _a.kind, colorOverride = _a.colorOverride, waiting = _a.waiting, almostActive = _a.almostActive, _b = _a.TagName, TagName = _b === void 0 ? "button" : _b, innerRef = _a.innerRef, children = _a.children, restProps = tslib_1.__rest(_a, ["disabled", "size", "block", "wide", "kind", "colorOverride", "waiting", "almostActive", "TagName", "innerRef", "children"]);
        var cssClasses = this.buildCssClasses();
        var props = tslib_1.__assign({}, restProps, { onClick: this.handleClick, className: classnames(cssClasses) });
        if (TagName === "input") {
            if (typeof children === "string" && !this.props.value) {
                props.value = children;
            }
            return React.createElement(TagName, tslib_1.__assign({}, props));
        }
        return (React.createElement(TagName, tslib_1.__assign({ ref: innerRef }, props), this.renderChildren()));
    };
    Button.propTypes = {
        id: PropTypes.string,
        name: PropTypes.string,
        innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
        kind: PropTypes.oneOf(exports.ButtonKindsArray).isRequired,
        size: PropTypes.oneOf(exports.ButtonSizesArray),
        block: PropTypes.bool,
        wide: PropTypes.bool,
        type: PropTypes.string,
        rel: PropTypes.string,
        href: PropTypes.string,
        TagName: PropTypes.oneOf(exports.ButtonTagNamesArray),
        target: PropTypes.string,
        /* Only relevant when TagName = "input" */
        value: PropTypes.string,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        waiting: PropTypes.bool,
        almostActive: PropTypes.bool,
        onClick: PropTypes.func,
        onMouseDown: PropTypes.func,
        colorOverride: PropTypes.oneOf(["dark-blue"])
    };
    Button.defaultProps = {
        kind: "primary",
        size: "medium",
        type: "button",
        TagName: "button"
    };
    return Button;
}(react_1.Component));
exports.Button = Button;